<template>
  <div :class="['navbarComp', !show ? 'none' : '']">
    <ul>
      <li v-for="(item, index) in items[role || 'dealer']" :key="index">
        <button :class="[active == item.view ? 'active':'','item']" @click="$router.push(`/${item.view}`)">
          {{ item.title }}
        </button>
      </li>
      <li>
        <div class="btn_signout">
          <button-comp :textBtn="'Выход'" :classBtn="'btn_orange'" :clickBtn="signOut"/>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'navbarComp',
  data: function () {
    return {
      items: {
        admin: [
          { title: 'Отчёты', view: 'stat' },
          { title: 'Кресла', view: 'kontrollers' },
          { title: 'Пользователи', view: 'users' },
          { title: 'Бонусы', view: 'bonuses' },
          { title: 'Заказы', view: 'orders' },
          { title: 'QR', view: 'purchases' },
          { title: 'Администраторы', view: 'admins' },
          { title: 'Проблемы', view: 'problems' },
          { title: 'Опрос', view: 'questions' },
          { title: 'Тех.поддержка', view: 'tickets' },
          { title: 'Промокоды', view: 'promocodes' },
          { title: 'Группы', view: 'groups' },
          { title: 'Акции', view: 'events' },
          // {title: 'Программы', view: 'programs'},
          { title: 'Настройки', view: 'config' }
        ],
        dealer: [
          { title: 'Отчёты', view: 'stat' },
          { title: 'Кресла', view: 'kontrollers' },
          { title: 'Заказы', view: 'orders' },
          { title: 'Тех.поддержка', view: 'tickets' },
          { title: 'Группы', view: 'groups' }
          // {title: 'Программы', view: 'programs'},
        ]
      }
    }
  },
  created: function () {
  },
  components: {},
  props: {
    active: {
      type: String,
      required: true
    }
  },
  computed: {
    show: function () {
      return this.$store.getters.getNavbar
    },
    role: function () {
      return localStorage.getItem('role')
    }
  },
  methods: {
    signOut () {
      this.$store.dispatch('auth/signOut')
    }
  }
}
</script>

<style scoped lang="scss">

.navbarComp {
  object-fit: contain;
  box-shadow: 0.5px 0 4px 0 rgba(0, 0, 0, 0.5);
  width: 230px;
  background-color: #fafafa;
  height: 100%;
}

ul {
  margin: 0;
  padding: 0;
}

li {
  list-style-type: none;
  text-align: left;
  margin: 30px auto auto 32px;
}

.item {
  background-color: transparent;
  border: none;

  font-size: 22px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  color: #202020;
}

.btn_signout {
  margin-right: 32px;
  margin-bottom: 32px;
  display: none;
}

.active {
  color: #ff8200;
}

.none {
  display: block;
}

button:active {
  opacity: 0.5;
}

@media screen and (max-width: 1140px) {
}

@media screen and (max-width: 960px) {
}

@media screen and (max-width: 720px) {
  .btn_signout {
    display: block;
  }
  .none {
    display: none;
  }
}

@media screen and (max-width: 540px) {
}

@media screen and (max-width: 480px) {
}

@media screen and (max-width: 320px) {
}

</style>
